const endpoints = {
    school: 'school',
    user: 'user',
    auth: 'auth',
    school_goal: 'school-goal',
    form_type: 'form-type',
    school_meta: 'school-meta',
};
export default endpoints;
